import { Box, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { gateway } from "../gateway";
import { createPlanState } from "../redux/features/createPlanStateSlice";
import { EBenefitTypes } from "../utils";

export const PlanBenefits = ({ setIsFormValid, readOnly = false }) => {
  const [coverageAreas, setCoverageAreas] = useState([]);
  const [connections, setConnections] = useState([]);
  const [coverageBenefit, setCoverageBenefit] = useState();
  const [connectionBenefit, setConnectionsBenefit] = useState();

  const dispatch = useDispatch();
  const newPlanState = useSelector((state) => state.createPlanState);
  const token = sessionStorage.getItem("token");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    dispatch(createPlanState({ [name]: value }));
  };

  const handleCoverageAreas = (event) => {
    const value = event.target.value;
    setCoverageBenefit(value);
    handleInputChange(event);
  };

  const handleConnections = (event) => {
    const value = event.target.value;
    setConnectionsBenefit(value);
    handleInputChange(event);
  };

  const getBenefits = async () => {
    try {
      const benefits = await gateway.get("/paypal/benefits", {
        headers: {
          Authorization: `${token}`,
        },
      });
      setCoverageAreas(benefits.data.data.filter((item) => item.type === EBenefitTypes.AREASCOVERAGES));
      setConnections(benefits.data.data.filter((item) => item.type === EBenefitTypes.FINDACLEANER));
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getBenefits();
  }, []);

  useEffect(() => {
    const isFormValid = newPlanState.coverageBenefit && newPlanState.connectionBenefit;
    setIsFormValid(isFormValid);
  }, [newPlanState.coverageBenefit, newPlanState.connectionBenefit]);

  const benefitsList = [
    {
      id: 7,
      name: "3 Coverage Areas",
      type: "areascoverages",
      config: '{"isLimitedUsage":true,"limitedUsage":3,"hexColor":"#6bbd00"}',
      createdAt: "2024-03-03T05:21:16.570Z",
      updatedAt: "2024-03-03T05:21:16.570Z",
      isActive: true,
    },
    {
      id: 8,
      name: "1 Coverage Areas",
      type: "areascoverages",
      config: '{"isLimitedUsage":true,"limitedUsage":1,"hexColor":"#6bbd00"}',
      createdAt: "2024-03-03T05:21:16.570Z",
      updatedAt: "2024-03-03T05:21:16.570Z",
      isActive: true,
    },
    {
      id: 9,
      name: "5 Coverage Areas",
      type: "areascoverages",
      config: '{"isLimitedUsage":true,"limitedUsage":5,"hexColor":"#6bbd00"}',
      createdAt: "2024-03-03T05:21:16.570Z",
      updatedAt: "2024-03-03T05:21:16.570Z",
      isActive: true,
    },
    {
      id: 5,
      name: "5+ Coverage Areas",
      type: "areascoverages",
      config: '{"isLimitedUsage":true,"limitedUsage":-1,"hexColor":"#6bbd00"}',
      createdAt: "2024-03-03T05:21:16.570Z",
      updatedAt: "2024-03-03T05:21:16.570Z",
      isActive: true,
    },
    {
      id: 12,
      name: "Get free support by email.",
      type: "support",
      config: '{"isSupportType":true,"supportType":"email"}',
      createdAt: "2024-05-14T23:56:15.109Z",
      updatedAt: "2024-05-14T23:56:15.109Z",
      isActive: true,
    },
    {
      id: 14,
      name: " Set at least 3 Coverage Areas for your organization",
      type: "areascoverages",
      config: '{"isLimitedUsage":true,"limitedUsage":3}',
      createdAt: "2024-05-14T23:56:15.695Z",
      updatedAt: "2024-05-14T23:56:15.695Z",
      isActive: true,
    },
    {
      id: 3,
      name: "3 Requests to Connect",
      type: "findacleaner",
      config: '{"isLimitedUsage":true,"limitedUsage":3,"hexColor":"#6bbd00", "isMonthlyReset":true}',
      createdAt: "2024-03-03T05:21:15.477Z",
      updatedAt: "2024-03-03T05:21:15.477Z",
      isActive: true,
    },
    {
      id: 1,
      name: "10 Requests to Connect",
      type: "findacleaner",
      config: '{"isLimitedUsage":true,"limitedUsage":10,"hexColor":"#6bbd00", "isMonthlyReset":true}',
      createdAt: "2024-03-03T05:08:55.929Z",
      updatedAt: "2024-03-03T05:08:55.929Z",
      isActive: true,
    },
    {
      id: 2,
      name: "30 Requests to Connect",
      type: "findacleaner",
      config: '{"isLimitedUsage":true,"limitedUsage":30,"hexColor":"#6bbd00", "isMonthlyReset":true}',
      createdAt: "2024-03-03T05:21:15.477Z",
      updatedAt: "2024-03-03T05:21:15.477Z",
      isActive: true,
    },
    {
      id: 4,
      name: "30+ Connections",
      type: "findacleaner",
      config: '{"isLimitedUsage":true,"limitedUsage":-1,"hexColor":"#6bbd00", "isMonthlyReset":true}',
      createdAt: "2024-03-03T05:21:15.477Z",
      updatedAt: "2024-03-03T05:21:15.477Z",
      isActive: true,
    },
    {
      id: 10,
      name: "Search at least 3 cleaners per month.",
      type: "findacleaner",
      config: '{"isLimitedUsage":true,"limitedUsage":3, "isMonthlyReset":true}',
      createdAt: "2024-05-14T23:56:14.508Z",
      updatedAt: "2024-05-14T23:56:14.508Z",
      isActive: true,
    },
    {
      id: 11,
      name: "Search at least 6 cleaners per month.",
      type: "findacleaner",
      config: '{"isLimitedUsage":true,"limitedUsage":6, "isMonthlyReset":true}',
      createdAt: "2024-05-14T23:56:14.820Z",
      updatedAt: "2024-05-14T23:56:14.820Z",
      isActive: true,
    },
    {
      id: 13,
      name: "Search at least 9 cleaners per month.",
      type: "findacleaner",
      config: '{"isLimitedUsage":true,"limitedUsage":9, "isMonthlyReset":true}',
      createdAt: "2024-05-14T23:56:15.408Z",
      updatedAt: "2024-05-14T23:56:15.408Z",
      isActive: true,
    },
    {
      id: 15,
      name: "Get free support by email.",
      type: "support",
      config: '{"isSupportType":true,"supportType":"email","isMonthlyReset":true}',
      createdAt: "2024-06-12T21:56:50.542Z",
      updatedAt: "2024-06-12T21:56:50.542Z",
      isActive: true,
    },
    {
      id: 16,
      name: " Set at least 3 Coverage Areas for your organization",
      type: "areascoverages",
      config: '{"isLimitedUsage":true,"limitedUsage":3,"isMonthlyReset":false}',
      createdAt: "2024-06-12T21:56:51.040Z",
      updatedAt: "2024-06-12T21:56:51.040Z",
      isActive: true,
    },
  ];

  return (
    <Box
      sx={{
        p: 4,
        borderRadius: 1,
        backgroundColor: "#white",
        display: "flex",
        flexDirection: "column",
        padding: "20px",
        alignItems: "center",
        transition: "opacity 1s ease-in-out",
        boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
        height: "auto",
        marginTop: 4,
        width: { xs: "100%", sm: 500 },
      }}
    >
      <Typography textAlign="center" fontWeight="bold" m={1}>
        Benefits
      </Typography>
      <Box sx={{ display: "flex" }}>
        <Box
          sx={{
            backgroundColor: "var(--fx-surface-base, #FFFFFF)",
            display: "flex",
            flexDirection: "column",
            width: "100%",
            borderRadius: 1,
            height: "auto",
            padding: "10px",
          }}
        >
          <FormControl component="fieldset">
            <FormLabel component="legend">Coverage areas</FormLabel>
            <RadioGroup aria-label="coverage-areas" name="coverageBenefit" value={newPlanState.coverageBenefit} onChange={handleCoverageAreas}>
              {coverageAreas.map((item) => (
                <FormControlLabel key={item.id} value={item.id} control={<Radio />} label={item.name} sx={{ mt: 0.5 }} disabled={readOnly} />
              ))}
            </RadioGroup>
          </FormControl>
        </Box>
        <Box
          sx={{
            backgroundColor: "var(--fx-surface-base, #FFFFFF)",
            display: "flex",
            flexDirection: "column",
            width: "100%",
            borderRadius: 1,
            height: "auto",
            padding: "10px",
          }}
        >
          <FormControl component="fieldset">
            <FormLabel component="legend">Connections</FormLabel>
            <RadioGroup aria-label="connection-requests" name="connectionBenefit" value={newPlanState.connectionBenefit} onChange={handleConnections} sx={{ mt: 0.5 }}>
              {connections.map((item) => (
                <FormControlLabel key={item.id} value={item.id} control={<Radio />} label={item.name} disabled={readOnly} />
              ))}
            </RadioGroup>
          </FormControl>
        </Box>
      </Box>
    </Box>
  );
};
